module.exports = __webpack_public_path__ + "media/fart-04.8cb0fb1a.mp3";